import { ObjectActionEventProperties } from '../../../analytics'
import { affiliations } from '../../../helpers/analytics-utils/constants'
import { SegmentAnalyticsCall } from '../../track-event'
import { transformObjectActionEventForSegment } from '..'
import makeProductBaseProperties from '../product-common'
import { LegacyDirectPurchaseEventData } from './types'

const decimalPlaces = 2

export function transformLegacyDirectPurchase(
  data: LegacyDirectPurchaseEventData
): SegmentAnalyticsCall {
  const cartAffiliation = affiliations.WESTFIELD_DIRECT_AU
  const currency = data.ecommerce.currencyCode

  type CartProduct =
    ObjectActionEventProperties['Order']['Completed']['products'][number]

  const cartProducts: CartProduct[] = data.ecommerce.purchase.products.map(
    product => {
      const cartProduct: CartProduct = {
        ...makeProductBaseProperties(product),
        currency,
        quantity: product.quantity,
      }

      if (product.category) {
        cartProduct.category_path = product.category

        const maxCategoryLimit = 5
        product.category
          .split(' / ')
          .forEach((category: string, index: number) => {
            if (index < maxCategoryLimit && category !== '') {
              const key = `category_${index + 1}` as const
              cartProduct[key] = category
            }
          })
      }

      return cartProduct
    }
  )
  const { billingAddress, shippingAddress } = data.ecommerce.purchase

  const shipping = Number(data.ecommerce.purchase.actionField.shipping)
  const total = Number(data.ecommerce.purchase.actionField.revenue)
  const tax = Number(data.ecommerce.purchase.actionField.tax)

  return transformObjectActionEventForSegment({
    object: 'Order',
    action: 'Completed',
    properties: {
      category: 'Ecommerce',
      label: 'order_completed',
      cart_id: data.cartId ? data.cartId : '',
      cart_affiliation: cartAffiliation,
      currency,
      products: cartProducts,
      total,
      revenue: Number(Number(total - shipping - tax).toFixed(decimalPlaces)),
      tax,
      order_id: data.ecommerce.purchase.actionField.id,
      shipping,
      shipping_address: shippingAddress
        ? {
            suburb: shippingAddress.suburb,
            postcode: shippingAddress.postCode,
            state_territory: shippingAddress.state,
            country: shippingAddress.country || 'AU',
          }
        : undefined,
      billing_address: {
        suburb: billingAddress.suburb,
        postcode: billingAddress.postCode,
        state_territory: billingAddress.state,
        country: billingAddress.country,
      },
      collect_location:
        data.ecommerce.purchase.deliveryType === 'CLICK_AND_COLLECT'
          ? data.ecommerce.purchase.collectLocation
          : '',
      delivery_type: data.ecommerce.purchase.deliveryType,
      payment_method: `credit card - ${data.ecommerce.purchase.paymentMethod}`,
    },
  })
}
